import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../common-data-model';

@Component({
    selector: 'app-appointment-details-popup',
    templateUrl: './appointment-details-popup.component.html',
    styleUrls: ['./appointment-details-popup.component.scss']
})

export class AppointmentDetailsPopupComponent implements OnInit {

    commonDataModel = new CommonDataModel();
    appointmentDetails = this.commonDataModel.appointmentDetailsModel;
    appointmentIncomingData: any;
    appointmentId: any;
    jobsPermission = this.commonDataModel.jobsPermissionModel;
    quotesPermission = this.commonDataModel.quotesPermissionModel;
    quickQuotesPermission = this.commonDataModel.quickQuotesPermissionModel;

    constructor(
        private commonService: CommonService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AppointmentDetailsPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog) {
        this.jobsPermission = this.commonService.permissionChecker(this.jobsPermission);
        this.quotesPermission = this.commonService.permissionChecker(this.quotesPermission);
        this.quickQuotesPermission = this.commonService.permissionChecker(this.quickQuotesPermission);
    }

    ngOnInit() {
        if (this.data) {
            this.appointmentIncomingData = this.data;
            this.appointmentId = this.appointmentIncomingData.appointmentId;
            this.getAppointmentDetailsById();
        }
    }

    getAppointmentDetailsById(): void {
        this.commonService.getAppointmentDetailsById(this.appointmentId).subscribe(response => {
            if (response.isSuccess) {
                this.appointmentDetails = response.data;
            }
        });
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

    onLoadJobDetails(data: any) {
        if (this.jobsPermission.ViewJobs) {
            if (data.isJob) {
                window.open(`app/jobs/job-details?jobId=${data.orderId}`, '_blank');
            } else {
                window.open(`app/quotes/quote-details?quoteId=${data.orderId}`, '_blank');
            }
        }
    }
}
